export default function pad(num) {
  return num < 10 ? "0".concat(num) : "".concat(num);
}